<div class="dialog-update-header">
  <h2 class="m-0">Update</h2>
</div>

<div mat-dialog-content>
  <h3>Ihr Hageda-Stumpf Apothekenportal wird aktualisiert.</h3>
  <p>Bitte warten Sie, bis die Installation abgeschlossen ist. Anschließend können Sie das Fenster schließen und die neuen Funktionen nutzen.</p>
  <div class="d-flex align-items-center">
    <mat-progress-bar
      mode="determinate"
      color="accent"
      [value]="progress()">
    </mat-progress-bar>
<!--    <h6 class="loadingPercentage" [style.left.%]="progress()">{{progress()}}%</h6>-->
<!--    @if (progress() < 100) {-->
<!--      <small class="ml-m phx-corporate font-weight-bold">Laden...</small>-->
<!--    }-->
  </div>

  <h3 class="updateHead">NEU:</h3>
  <ul class="check-list mb-0">
    @for (content of listItems(); track $index) {
      <li [innerHTML]="content"></li>
    }
  </ul>

  @if (progress() < 100) {
    <div class="dotLoader"></div>
  }
</div>

<div mat-dialog-actions class="mb-s d-flex justify-content-end">
  @if (error()) {
    <p class="text-danger" role="alert">{{ error() }}</p>
  }
  <button
    mat-flat-button
    (click)="onSubscribe('update')"
    [disabled]="!isComplete() || saving()">
    {{data.button}}
  </button>
</div>
